
































































































import { Component, Vue } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import { Auth } from 'aws-amplify';

@Component({
  components: {
    CommonButton,
  },
})
export default class ChangePasswordBase extends Vue {
  private theoryLogo: string = require('../../assets/logotest.png');
  private buttonColor = '#4384f3';
  private textFieldColor: string = '#3c3c3c';
  private oldPassword  = '';
  private newPassword = '';
  private passwordConfirmation = '';
  private showOldPassword = false;
  private showNewPassword = false;
  private showPasswordConfirmation  = false;
  private message = '';

  private setMessage(message: string): void {
    this.message = message;
  }

  private async onChangePassword() {
    if (!this.validateChangePasswordParam()) {
      return;
    }
    await this.changePassword();
  }

  private async changePassword() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(user, this.oldPassword, this.newPassword);
      alert('パスワードが変更されました。');
      this.$router.push({ name: 'home' });
    } catch (error) {
      if (error.code) {
        switch (error.code) {
          case 'NotAuthorizedException':
            this.setMessage('旧パスワードが正しくありません。');
            break;
          case 'LimitExceededException':
            this.setMessage('旧パスワードの送信可能回数が上限に達しました。');
            break;
          case 'InvalidPasswordException':
            this.setMessage('このパスワードは使用できません。');
            break;
          case 'InvalidParameterException':
            this.setMessage('入力項目に有効でない値が含まれています。');
            break;
          default:
            this.setMessage('予期しないエラーが発生しました。');
            break;
        }
      } else {
        this.setMessage('予期しないエラーが発生しました。');
      }
    }
  }

  private validateChangePasswordParam() {
    if (
      this.oldPassword === '' ||
      this.newPassword === '' ||
      this.passwordConfirmation === ''
    ) {
      this.setMessage('旧パスワード、新しいパスワード、新しいパスワード（確認）は必須です。');
      return false;
    } else if (this.newPassword !== this.passwordConfirmation) {
      this.setMessage('パスワードとパスワード（確認用）が異なっています。');
      return false;
    } else {
      this.setMessage('');
      return true;
    }
  }
}
